import React, { useEffect, useRef } from 'react';

const Overlay = ({ children }) => {
  const overlayRef = useRef(null);

  useEffect(() => {
    const overlay = overlayRef.current;

    const stopPropagation = (e) => {
      e.stopPropagation();
    };

    // Add event listeners to stop propagation
    overlay.addEventListener('mousedown', stopPropagation);
    overlay.addEventListener('mousemove', stopPropagation);
    overlay.addEventListener('touchstart', stopPropagation);

    return () => {
      // Clean up event listeners
      overlay.removeEventListener('mousedown', stopPropagation);
      overlay.removeEventListener('mousemove', stopPropagation);
      overlay.removeEventListener('touchstart', stopPropagation);
    };
  }, []);

  return (
    <div ref={overlayRef} className="overlay">
      {children}
    </div>
  );
};

export default Overlay;